const validate = (values) => {
  const errors = {};
  if (!values.schoolClass) {
    errors.schoolClass = 'Esse campo não pode ficar vazio';
  }
  if (!values.subject) {
    errors.subject = 'Esse campo não pode ficar vazio';
  }
  if (!values.classSequence) {
    errors.classSequence = 'Esse campo não pode ficar vazio';
  }
  if (!values.workSubject) {
    errors.workSubject = 'Esse campo não pode ficar vazio';
  }
  if (!values.description) {
    errors.description = 'Esse campo não pode ficar vazio';
  }
  return errors;
};

export default validate;
